<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <div class="card">
            <div class="card-body">
                <div class="row mb-10">
                    <div class="col-md-12  mb-10">
                        <h6 class="content-header-title
                            float-left mb-0">
                            Payment
                        </h6>
                    </div>
                    <div class="col-md-12">
                        <div class="fs-11">Complete your payment successfully to proceed with your request.
                        </div>
                    </div>
                </div>

                <loader *ngIf="showLoader"></loader>

        <div class="d-flex row align-items-stretch retry-payment-section">
            <div class="currency-panel col-12 col-md-6 pl-0">



                <!-- <div class="row mb-20 mt-30">
                    <div class="col-md-3 mb-10">
                        <div class=" text-black fs-11 bg-light-grey p-10 border-grey">Item </div>
                        <div class="text-black fs-12 fw-600 p-10 border-grey"> {{ this.orderDetails?.orderItems[0]?.product}} </div>
                    </div>
                    <div class="col-md-3 mb-10">
                        <div class="text-black fs-11 bg-light-grey p-10 border-grey">IBR </div>
                        <div class="text-black fs-12 fw-600 p-10 border-grey"> 1 {{this.orderDetails?.orderItems[0]?.currencyCode}} = INR {{this.orderDetails?.orderItems[0]?.bidRate}}
                        </div>
                    </div>
                    <div class="col-md-3 mb-10">
                        <div class="text-black fs-11 bg-light-grey p-10 border-grey">Quantity </div>
                        <div class="text-black fs-12 fw-600 p-10 border-grey">
                            {{this.orderDetails?.orderItems[0]?.currencyAmount}}
                        </div>
                    </div>
                    <div class="col-md-3 mb-10">
                        <div class="text-black fs-11 bg-light-grey p-10 border-grey">Price </div>
                        <div class="text-black fs-12 fw-600 p-10 border-grey"> ₹ {{this.orderDetails?.orderItems[0]?.billableAmount}}
                        </div>
                    </div>
                </div> -->

                <div class="row">
                    <div class="col-md-8 col-12">
                        <div class="fs-14 text-black fw-600">
                            Choose Your Bank Account
                        </div>
                    </div>
                    <div class="col-md-4 col-12">
                        <button type="button" class="btn btn-primary btn-prev fs-12" rippleEffect
                            routerLink="/add-bank-account">
                            Add Bank Account
                        </button>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 mb-20" *ngFor="let singleBank of bankAccountList; let i=index">
                        <div [ngClass]="(bankAccountList.length - 1) == i ? 'border-bottom-white' : 'border-bottom-grey' ">
                            <div class="row mb-10">
                                <div class="col-md-11 col-10">
                                    <input type="radio" name="radios" id="radio" (change)="getSelectedBankAccountID(singleBank.id)" />
                                    <span class="card-title fs-12 text-black fw-600 mb-10">
                                        {{singleBank.bankName}}
                                    </span>
                                    <div class="fs-11 ml-15"> Account No : {{singleBank.number}}</div>
                                    <div class="fs-11 ml-15 "> IFSC Code : {{singleBank.ifscCode}}</div>
                                    <div class="fs-11 ml-15 "> Branch : {{singleBank.branch}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-30">
                    <div class="col-md-12">
                        <div class="fs-12 text-black fw-600 mb-20">
                            Payment Method
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 fs-11">
                        <input type="radio" name="paymentType" id="radio" value='FULL' [(ngModel)]="isPartial" (click)="getSelectedPaymentType(false)" /> Full Payment
                    </div>
                    <div class="col-md-4 text-right fw-600">
                        ₹ {{ xplorerOrderDetail ? xplorerOrderDetail?.totalAmount : orderDetails?.invoice?.totalBillAmountString }}
                    </div>
                </div>
                <!-- <div class="row mt-20">
                    <div class="col-md-3 fs-11">
                        <input type="radio" name="paymentType" id="radio" value='PAY' [(ngModel)]="isPartial" (click)="getSelectedPaymentType(true)" /> Book and Pay
                    </div>
                    <div class="col-md-2 text-right fw-600">
                        ₹ {{this.orderDetails?.invoice?.partialBillableAmount}}
                    </div>
                </div> -->
                <!-- <div class="row mt-10">
                    <div class="col-md-12 fs-9 text-danger fw-600">
                        ₹ {{this.orderDetails?.partialAmountNote}}
                    </div>
                </div> -->


                <div class="row mt-30">
                    <div class="col-md-12">
                        <div class="fs-12 text-black fw-600 mb-20">
                            Payment Mode
                        </div>
                    </div>
                </div>

                <div class="row mb-30">
                    <div class="col-md-4 col-12 fs-12" *ngIf="!xplorerOrderDetail">
                        <input type="radio" name="paymentRadio" id="radio" value='NB' [(ngModel)]="paymentMode" (click)="getSelectedPaymentMode('NB')" /> &nbsp; &nbsp; Net Banking
                    </div>
                    <div class="col-md-4 col-12 fs-12  " *ngIf="showNEFT && !xplorerOrderDetail">
                        <input type="radio" name="paymentRadio" id="radio" value='MANUAL' [(ngModel)]="paymentMode" (click)="getSelectedPaymentMode('MANUAL')" /> &nbsp; &nbsp; NEFT/RTGS/IMPS
                    </div>
                    <div class="col-md-4 col-12 fs-12  ">
                        <input type="radio" name="paymentRadio" id="radio" value='UPI' [(ngModel)]="paymentMode" (click)="getSelectedPaymentMode('UPI')" /> &nbsp; &nbsp; UPI
                    </div>

                    <div class="col-md-12 mt-30" *ngIf="selectedPaymentMode == 'MANUAL'">
                        <div class="fs-12 fw-500  text-black">{{accountName}}
                        </div>
                        <div class="fs-11  text-black">{{bankName}}</div>
                        <div class="fs-11  text-black">{{accountNo}}</div>
                        <div class="fs-11  text-black">{{bankIFSC}}</div>
                        <div class="fs-11  text-black">{{bankBranch}}</div>
                    </div>

                    <div class="col-md-12 fs-10 text-danger mt-30 mb-30 text-500" *ngIf="selectedPaymentMode == 'MANUAL'">
                        Note: Please send an NEFT/RTGS/IMPS payment towards your order to the above account. The payment is to be transferred within 8 hours of order completion and the reference details of the transfer is to be updated in the My Order section on the WSFx Global
                        Pay App.
                    </div>
                </div>

                <div class="d-flex justify-content-between">
                    <div></div>
                    <button class="btn btn-primary" rippleEffect (click)="proceedToPayment()">Proceed</button>
                </div>

                            </div>
        

            <div class="currency-panel col-12 col-md-6 pr-0">
                <div class="forex-item-list forex-item-detail mb-10" *ngIf="!xplorerOrderDetail">
                        <table class="table table-bordered">
                            <caption class="visually-hidden">Forex Product deatils</caption>
                            <thead>
                                <tr class="table-header">
                                    <th scope="row">Product</th>
                                    <th scope="row">Currency</th>
                                    <th scope="row">FX Amount</th>
                                    <th scope="row">Rate</th>
                                </tr>
                            </thead>
                            <tbody class="fs-10 text-black">
                                <tr *ngFor="let singleTransaction of orderDetails?.orderItems; let i = index">
                                    <th scope="row" class="mob-table">Product</th>
                                    <td>

                                        {{singleTransaction?.product}}
                                    </td>
                                    <th scope="row" class="mob-table">Currency</th>
                                    <td>
                                        {{singleTransaction?.currencyCode}}
                                    </td>
                                    <th scope="row" class="mob-table">FX Amount</th>
                                    <td>
                                        {{singleTransaction?.currencyAmount}}
                                    </td>
                                    <th scope="row" class="mob-table">Rate</th>
                                    <td>
                                        {{singleTransaction.ibrRate}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                </div>
                <div class="currency-panel-box-wrapper" *ngIf="xplorerOrderDetail">
                    <div class="xplorer-breakup-wrapper">
                        <div class="table-responsive amout-breakup-bg tansaction-breakup">
                            <table class="table table-condensed table-borderless  fs-12">
                            <caption class="visually-hidden">Xplorer Kit deatils</caption>
                                <thead class="visually-hidden">
                                    <tr>
                                    <th scope="col" colspan="4"><span></span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style="background-color: #E8E8E8;">
                                        <td class="thick-line text-black fw-600" colspan="4">
                                            <div class="d-flex flex-row">
                                                <div class="breakup-forex-icon"><img src="assets/images/icon/Card details.png" alt="card icons" /></div><span>Xplorer Card Details</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="no-line " colspan="3"><strong>Kit Fee : </strong></td>
                                        <td class="no-line text-right">₹ {{ orderDetails?.invoice?.xplorerCardDetails?.kitFee || xplorerOrderDetail?.kitFee }} </td>
                                    </tr>
                                    <tr>
                                        <td class="no-line " colspan="3"><strong>GST</strong></td>
                                        <td class="no-line text-right">₹ {{ orderDetails?.invoice?.xplorerCardDetails?.gst || xplorerOrderDetail?.gst }} </td>
                                    </tr>
                                    <tr style="border-top:1px solid #EBEBEB; background:#E8E8E8;">
                                        <td class="no-line text-black fw-800 pt-10" colspan="3">Total Kit Amount</td>
                                        <td class="no-line text-right text-black fw-800 pt-10"> ₹ {{ orderDetails?.invoice?.xplorerCardDetails?.totalAmount || xplorerOrderDetail?.totalAmount }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="currency-panel-box-wrapper mt-2" *ngIf="!xplorerOrderDetail">
                    <div class="amount-breakup-wrapper">


                        <table class="table table-condensed table-borderless amout-breakup-bg  fs-12" >
                            <caption class="visually-hidden">Forex order product deatils</caption>  
                                <thead class="visually-hidden">
                                    <tr>
                                    <th scope="col" colspan="4"><span></span></th>
                                    </tr>
                                </thead>                            
                            <tbody>
                                <tr style="background-color: #E8E8E8;">
                                    <td class="thick-line text-black fw-600" colspan="4">
                                        <div class="d-flex flex-row">
                                            <div class="breakup-forex-icon"><img src="assets/images/icon/Forex Details.png" alt="forex details" style="width: 25px;" /></div><span>Forex Details</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="thick-line text-black fw-600" colspan="3"><strong>Amount</strong></td>
                                    <td class="no-line text-right"> ₹ {{orderDetails?.invoice?.billableAmountString}}
                                    </td>
                                </tr>
                                <!-- <tr>
                                    <td class="no-line " colspan="3"><strong>Forex Margin</strong></td>
                                    <td class="no-line text-right">₹ {{ stepperDataCardModel?.quotationResponse.marginChargesString }} </td>
                                </tr> -->
                                <tr *ngIf="orderDetails?.invoice?.totalHandlingChargesString != 0 && orderDetails?.invoice?.totalHandlingChargesString != 0.0">
                                    <td class="no-line " colspan="3"><strong>Service Charges </strong></td>
                                    <td class="no-line text-right">+ ₹ {{orderDetails?.invoice?.totalHandlingChargesString}}</td>
                                </tr>
                                <tr class="no-line" *ngIf="orderDetails?.invoice?.deliveryCharges != 0 && orderDetails?.invoice?.deliveryCharges != 0.0">
                                    <td class="no-line " colspan="3"><strong>Delivery Charges </strong></td>
                                    <td class="no-line text-right"> + ₹ {{orderDetails?.invoice?.deliveryCharges}}</td>
                                </tr>
                                <tr class="no-line" *ngIf="orderDetails?.invoice?.totalTaxesString != 0 && orderDetails?.invoice?.totalTaxesString != 0.0">
                                    <td class="no-line " colspan="3"><strong>GST </strong></td>
                                    <td class="no-line text-right"> + ₹ {{orderDetails?.invoice?.totalTaxesString}}</td>
                                </tr>
                                <tr *ngIf="orderDetails?.tcs?.tcsAmountString1 != 0 && orderDetails?.tcs?.tcsAmountString1 != 0.0">
                                    <td class="no-line " colspan="3"><strong>TCS ({{ orderDetails?.tcs?.tcsPercentageString1 }}%)</strong></td>
                                    <td class="no-line text-right">+ ₹ {{ orderDetails?.tcs?.tcsAmountString1 }}</td>
                                </tr>
                                <tr class="no-line" *ngIf="orderDetails?.invoice?.totalDiscount">
                                    <td class="no-line " colspan="3"><strong>Coupon Code </strong></td>
                                    <td class="no-line text-right">- ₹ {{orderDetails?.invoice?.totalDiscount}}</td>
                                </tr>
                                <tr class="no-line" *ngIf="orderDetails?.redeemedPoints != 0 && orderDetails?.redeemedPoints != 0.0">
                                    <td class="no-line " colspan="3"><strong>Redeemed Points </strong></td>
                                    <td class="no-line text-right">- ₹ {{orderDetails?.redeemedPoints}}</td>
                                </tr>

                                <tr style="border-top:1px solid #EBEBEB; background:#E8E8E8;">
                                    <td class="no-line text-black fw-800 pt-10" colspan="3">Total Payable: </td>
                                    <td class="no-line text-right text-black fw-800 pt-10">₹ {{ orderDetails?.invoice?.totalPaymentPendingString }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>


                    </div>
                </div>
            </div>
        </div>

            </div>
        </div>
    </div>
</div>